<template>
  <div>
    <vue-toastr ref="toast"></vue-toastr>
    <table class="table table-bordered mb-0">
      <thead>
      <tr>
        <th>ID</th>
        <th>Reduzierungsart</th>
        <th>Startdatum</th>
        <th>Enddatum</th>
        <th>Aktionen</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in items" :key="item.id || 'new-' + index">
        <td>{{ item.id }}</td>
        <td>
          <select v-model="item.discount_type" :disabled="!item.editing" class="form-control">
            <option v-for="(label, value) in discountTypes" :key="value" :value="value">
              {{ label }}
            </option>
          </select>
        </td>
        <td>
          <input v-model="item.valid_from" :disabled="!item.editing" class="form-control" type="date"/>
        </td>
        <td>
          <input v-model="item.valid_until" :disabled="!item.editing" class="form-control" type="date"/>
        </td>
        <td class="text-center">
          <button v-if="!item.editing" class="btn btn-outline btn-warning" type="button" @click="editItem(index)">
            <i class="fa fa-pencil"></i>
          </button>
          <button v-if="item.editing" :disabled="saving" class="btn btn-outline btn-primary" type="button"
                  @click="saveItem(index)">
            <i class="fa fa-check"></i>
          </button>
          <button :disabled="saving" class="btn btn-outline btn-danger" type="button"
                  @click="deleteItem(item.id, index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <button class="btn btn-block btn-outline btn-info btn-sm" type="button" @click="addItem($event)">
      <i class="fa fa-plus"></i> Hinzufügen
    </button>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import axios from "axios";

export default {
  name: "LoyaltySettingExclusionsDiscount",
  components: {VueToastr},
  data() {
    return {
      items: [],
      discountTypes: {
        1: "Artikelreduzierung",
        2: "Rabattierungen"
      },
      saving: false,
    };
  },
  props: {
    settingId: {
      type: [String, Number],
      required: true
    },
    clientId: {
      type: [String, Number],
      required: true
    },
    exclusionDiscount: Object,
  },
  mounted() {
    this.fetchExclusions();
  },
  methods: {
    async fetchExclusions() {
      try {
        const response = await axios.get(`/backend/loyalty-program/settings/${this.settingId}/exclusion-discounts`);
        this.items = response.data.exclusionDiscounts.map(exclusion => ({
          id: exclusion.id,
          discount_type: exclusion.discount_type,
          valid_from: exclusion.valid_from || "",
          valid_until: exclusion.valid_until || "",
          editing: false
        }));
      } catch (error) {
        this.$refs.toast.e("Fehler beim Laden der Ausschlüsse.", "Fehler");
      }
    },
    addItem() {
      this.items.push({
        id: null,
        discount_type: "",
        valid_from: "",
        valid_until: "",
        editing: true
      });
    },
    editItem(index) {
      this.items[index].editing = true;
    },
    async saveItem(index) {
      this.saving = true;
      const item = this.items[index];

      const payload = {
        id: item.id,
        loyalty_setting_id: this.settingId,
        discount_type: item.discount_type,
        valid_from: item.valid_from || null,
        valid_until: item.valid_until || null,
      };

      try {
        let response;
        if (item.id) {
          const exclusionDiscountId = Number(item.id);
          response = await axios.put(`/backend/loyalty-program/settings/${this.settingId}/exclusion-discounts/${exclusionDiscountId}`, payload);
        } else {
          response = await axios.post(`/backend/loyalty-program/settings/${this.settingId}/exclusion-discounts`, payload);
          item.id = response.data.exclusionDiscount.id;
        }
        item.editing = false;
        this.$refs.toast.s("Ausschluss nach Rabattaktionen erfolgreich gespeichert!", "Erfolg");
      } catch (error) {
        console.error(error.response?.data || error.message);
        this.$refs.toast.e("Fehler beim Speichern des Ausschluss nach Rabattaktionen.", "Fehler");
      } finally {
        this.saving = false;
      }
    },
    async deleteItem(id, index) {
      if (!id) {
        this.items.splice(index, 1);
        return;
      }

      if (!confirm("Möchten Sie diesen Ausschluss nach Rabattaktionen wirklich löschen?")) {
        return;
      }

      this.saving = true;
      try {
        await axios.delete(`/backend/loyalty-program/settings/${this.settingId}/exclusion-discounts/${id}`);
        this.items.splice(index, 1);
        this.$refs.toast.s("Ausschluss nach Rabattaktionen erfolgreich gelöscht!", "Erfolg");
      } catch (error) {
        this.$refs.toast.e("Fehler beim Löschen des Ausschluss nach Rabattaktionen.", "Fehler");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.table {
  margin-top: 20px;
}
</style>
